import axiosInstance from "./client";
import { TNotificationData } from "~/types";

export const sentFCMToken = async (token: string, validTime: string) => {
  const response = await axiosInstance.post(`/notification/send-FCM-token`, {
    FCM_token: token,
    expiredAt: validTime,
  });

  return response;
};

export const getTotalNotify = async (): Promise<{ total: string }> => {
  const response = await axiosInstance.get(`/notification/total`);

  return response.data;
};

export const getNotifyList = async (): Promise<TNotificationData[]> => {
  let ret: TNotificationData[] = [];
  const response = await axiosInstance.get(`/notification/all`);
  response?.data?.map((notify: any) => {
    ret.push({
      id: notify?.notificationID,
      ...notify,
    });
  });

  return ret;
};

export const readNotify = async (notifyId?: number) => {
  let response;
  if (notifyId) {
    response = await axiosInstance.patch(`/notification/mark-as-read`, {
      notificationID: notifyId,
    });
  } else {
    response = await axiosInstance.patch(`/notification/mark-as-read`);
  }

  return response.data;
};
